var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 72 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9711 20.082C40.5655 19.7336 40.3322 19.2255 40.3322 18.6908V10.2508C40.3322 7.48942 38.0936 5.25084 35.3322 5.25084H8.66783C5.90641 5.25084 3.66783 7.48942 3.66783 10.2508V52.7492C3.66783 55.5106 5.90641 57.7492 8.66783 57.7492H35.3322C38.0936 57.7492 40.3322 55.5106 40.3322 52.7492V44.2992C40.3322 43.7645 40.5655 43.2565 40.9711 42.9081V42.9081C42.1604 41.8866 44 42.7315 44 44.2992V58C44 60.7614 41.7614 63 39 63H5C2.23858 63 0 60.7614 0 58V5C0 2.23858 2.23858 0 5 0H39C41.7614 0 44 2.23858 44 5V18.6908C44 20.2585 42.1604 21.1034 40.9711 20.082V20.082Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.908 32.2355C70.5598 31.8479 70.5598 30.9041 69.908 30.5165L47.6729 17.2936C47.0063 16.8972 46.1617 17.3776 46.1617 18.1531V27.751C46.1617 28.3033 45.714 28.751 45.1617 28.751H13C12.4477 28.751 12 29.1987 12 29.751V33C12 33.5523 12.4477 34 13 34H45.1617C45.714 34 46.1617 34.4477 46.1617 35V44.5979C46.1617 45.3735 47.0062 45.8538 47.6728 45.4574L69.908 32.2355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutArrow);
export default __webpack_public_path__ + "static/media/outArrow.70e46f164cc100ea14c5e7486b6e3eb0.svg";
export { ForwardRef as ReactComponent };